export default "__VITE_ASSET__DKnNW9I9__"